import React, { useEffect, useMemo, useRef, useState } from "react";

// Tablas de los reportes: en vez de pintar miles de filas de golpe, se pintan
// por tandas (PASO filas) y se añade otra tanda al acercarse al final con el scroll.
// Los totales, gráficas y filtros siguen usando todos los datos; esto solo afecta a la tabla.
const PASO = 100;

// filas: filas de la tabla (modo un día). grupos: [{dias: [...]}] (modo varios días),
// se cortan por grupos completos hasta llegar al límite de filas.
export function useCargaProgresiva(filas, grupos) {
  const [limite, setLimite] = useState(PASO);
  // al cambiar los datos o los filtros, se vuelve a empezar por arriba
  useEffect(() => { setLimite(PASO); }, [filas, grupos]);

  const filasMostradas = useMemo(() => filas.slice(0, limite), [filas, limite]);
  const gruposMostrados = useMemo(() => {
    let n = 0, i = 0;
    while (i < grupos.length && n < limite) { n += grupos[i].dias.length; i++; }
    return i === grupos.length ? grupos : grupos.slice(0, i);
  }, [grupos, limite]);

  const total = filas.length;
  const mostradas = grupos.length ? gruposMostrados.reduce((a, g) => a + g.dias.length, 0) : filasMostradas.length;
  const hayMas = mostradas < total;
  const mas = () => setLimite((l) => l + PASO);
  return { filasMostradas, gruposMostrados, hayMas, mostradas, total, mas };
}

// Marcador al final de la tabla: cuando entra cerca de la pantalla, carga la siguiente tanda.
// El botón queda como alternativa si el navegador no avisa del scroll.
export function MasFilas({ hayMas, mostradas, total, mas }) {
  const ref = useRef(null);
  useEffect(() => {
    if (!hayMas || !ref.current || typeof IntersectionObserver === "undefined") return undefined;
    const obs = new IntersectionObserver((ents) => { if (ents.some((e) => e.isIntersecting)) mas(); }, { rootMargin: "600px 0px" });
    obs.observe(ref.current);
    return () => obs.disconnect();
  }, [hayMas, mostradas]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!hayMas) return null;
  return (
    <div ref={ref} style={{ textAlign: "center", padding: "14px 0", fontSize: 13, color: "#64748b" }}>
      Mostrando {mostradas} de {total} filas ·{" "}
      <button type="button" onClick={mas} style={{ border: "1px solid #cbd5e1", background: "#fff", borderRadius: 999, padding: "4px 12px", fontWeight: 700, color: "#4338ca", cursor: "pointer" }}>
        Cargar más
      </button>
    </div>
  );
}
